import { render, staticRenderFns } from "./serviceRequest.vue?vue&type=template&id=61b14414&"
import script from "./serviceRequest.vue?vue&type=script&lang=js&"
export * from "./serviceRequest.vue?vue&type=script&lang=js&"
import style0 from "./serviceRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports